import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { MenuProps } from 'antd';
import { Dropdown, Modal } from 'antd';
import { ExclamationCircleOutlined, MoreOutlined } from '@ant-design/icons';
import { DeleteOutlined } from '@ant-design/icons';
import { useDeleteCargoTrip } from 'api/trips/use-delete-cargo-trip.ts';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import type { TDropdownChangeInfo } from 'types/dropdown-change-info';
import type { ITripCargoControlProps } from './types';

export const TripCargoControlComponent: React.FC<ITripCargoControlProps> = (props) => {
  const { cargoTrip } = props;

  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();
  const { mutateAsync: deleteCargoTrip } = useDeleteCargoTrip();

  const [isActiveControl, setIsActiveControl] = useState(false);

  const deactivateWithTimeout = () => {
    setTimeout(() => setIsActiveControl(false), 300);
  };

  const confirm = () => {
    modal.confirm({
      title: t('common:confirm'),
      icon: <ExclamationCircleOutlined />,
      content: t('common:delete_confirm_text'),
      okText: t('common:delete'),
      cancelText: t('common:cancel'),
      onCancel: () => deactivateWithTimeout(),
      onOk: async () => {
        await deleteCargoTrip({
          tripId: cargoTrip.tripId,
          cargoTripId: cargoTrip.id,
          cargoId: cargoTrip.cargoId,
        });
        deactivateWithTimeout();
      },
    });
  };

  const handleDropdownClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'delete') {
      confirm();
    }
  };

  const handleDropdownOpenChange = (value: boolean, info: TDropdownChangeInfo) => {
    if (info.source === 'trigger') {
      setIsActiveControl(value);
    }
  };

  return (
    <>
      <Dropdown
        key='more'
        trigger={['click']}
        menu={{
          items: [
            {
              key: 'delete',
              label: t('common:delete'),
              icon: <DeleteOutlined />,
            },
          ],
          onClick: handleDropdownClick,
        }}
        placement='bottomLeft'
        onOpenChange={handleDropdownOpenChange}>
        <MoreOutlined style={{ fontSize: 20 }} />
      </Dropdown>
      {isActiveControl ? <>{contextHolder}</> : null}
    </>
  );
};

export const TripCargoControl = withRoleGuard(TripCargoControlComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.transport_manager,
]);
